import { render } from "./HomeCarousel.vue?vue&type=template&id=1d824fb1&scoped=true"
import script from "./HomeCarousel.vue?vue&type=script&lang=js"
export * from "./HomeCarousel.vue?vue&type=script&lang=js"

import "./HomeCarousel.vue?vue&type=style&index=0&id=1d824fb1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d824fb1"]])

export default __exports__